import { jsx as x } from "react/jsx-runtime";
import { c as k } from "react/compiler-runtime";
import { Marker as G } from "@react-google-maps/api";
import { memo as S } from "react";
import T from "./index.js";
const j = (y) => {
  const t = k(19), {
    lat: i,
    lng: n,
    width: M,
    height: g,
    zoom: v,
    icon: m,
    apiKey: a,
    hideMarker: p,
    mapType: w
  } = y, l = M === void 0 ? "100%" : M, d = g === void 0 ? "300px" : g, f = v === void 0 ? 8 : v, h = w === void 0 ? "roadmap" : w, z = i || 0, u = n || 0;
  let o;
  t[0] !== z || t[1] !== u ? (o = {
    lat: z,
    lng: u
  }, t[0] = z, t[1] = u, t[2] = o) : o = t[2];
  let s;
  t[3] !== o || t[4] !== f ? (s = {
    center: o,
    zoom: f
  }, t[3] = o, t[4] = f, t[5] = s) : s = t[5];
  const e = s;
  let r;
  t[6] !== p || t[7] !== m || t[8] !== i || t[9] !== n ? (r = !p && /* @__PURE__ */ x(G, { icon: m, position: {
    lat: i,
    lng: n
  } }), t[6] = p, t[7] = m, t[8] = i, t[9] = n, t[10] = r) : r = t[10];
  let c;
  return t[11] !== a || t[12] !== e.center || t[13] !== e.zoom || t[14] !== d || t[15] !== h || t[16] !== r || t[17] !== l ? (c = /* @__PURE__ */ x(T, { showAddressInput: !1, apiKey: a, center: e.center, zoom: e.zoom, width: l, height: d, mapType: h, children: r }), t[11] = a, t[12] = e.center, t[13] = e.zoom, t[14] = d, t[15] = h, t[16] = r, t[17] = l, t[18] = c) : c = t[18], c;
}, _ = S(j);
export {
  _ as default
};
